import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian thống kê: ", -1)
const _hoisted_5 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Chọn nơi trả hồ sơ: ", -1)
const _hoisted_7 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Không có thông tin danh sách hồ sơ. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách hồ sơ đã thanh toán" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Calendar, {
              id: "date",
              modelValue: $setup.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event)),
              selectionMode: "range",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              yearRange: "2000:2100",
              onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectCalendar())),
              onClearClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearCalendar()))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_Dropdown, {
              id: "kind",
              modelValue: $setup.select,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.select) = $event)),
              options: $setup.location,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Vui lòng chọn ...",
              onChange: $setup.selectKind
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DataTable, {
              value: $setup.listHSDVC,
              paginator: true,
              stripedRows: "",
              rows: 10,
              rowsPerPageOptions: [10,25,50],
              rowHover: true,
              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
              globalFilterFields: ['hoVaTen','soDienThoai','thoiGian'],
              currentPageReportTemplate: "Có tất cả {totalRecords} hồ sơ",
              filters: _ctx.filters,
              "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters) = $event)),
              style: {"font-size":"13px"}
            }, {
              empty: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "chuHoSo",
                  header: "Chủ HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "nguoiNopHoSo",
                  header: "Người nộp HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "dienThoaiChuHoSo",
                  header: "Số điện thoại chủ HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "diaChiChuHoSo",
                  header: "Địa chỉ chủ HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "maSoHoSo",
                  header: "Mã số HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "dinhDanhChuHoSo",
                  header: "CCCD/CMND chủ HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "trichYeu",
                  header: "Trích yếu",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  header: "Lệ phí",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatCurrency(data.lePhi)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "ngayNhan",
                  dataType: "date",
                  header: "Thời gian nhận HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "tranferTime",
                  dataType: "date",
                  header: "Thời gian thanh toán",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatDateTime(data.tranferTime)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "tienThanhToan",
                  header: "Số tiền đã thanh toán",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatCurrency(data.tienThanhToan)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: "Nơi trả HS",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    ($setup.checkKind(data.lePhi, data.tienThanhToan))
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          style: {"max-width":"100px"},
                          severity: "info",
                          label: "Tại quận",
                          icon: "pi pi-building-columns",
                          iconPos: "left"
                        }))
                      : (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          style: {"max-width":"100px"},
                          label: "Tại nhà",
                          severity: "danger",
                          icon: "pi pi-warehouse",
                          iconPos: "left"
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "filters"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}